import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { DocumentPath } from "@/Documents/Api/Dto/Response/DocumentPath";

interface IAttachmentsTooltip {
    Attachements: DocumentPath[];
    leftPosition: number;
    topPosition: number;
}

class AttachmentsTooltipControl extends React.Component<IAttachmentsTooltip, never> {
    private helper = new MyleHelper();

    public render(): JSX.Element {
        const self = this;

        const style: React.CSSProperties = {
            position: "absolute",
            left: self.props.leftPosition + "px",
            top: self.props.topPosition + "px"
        };

        var arrAttachments = this.props.Attachements.map((att: DocumentPath, idx) => {
            var self = this;
            return (
                <div key={idx + "___dssddsd"}>
                    <a onClick={self.OpenDocument.bind(self, att)} target="_blank">{this.helper.GetReadableFileName(att.FileName)}</a>
                </div>
            );
        });

        return (
            <div id="muli_file_wd" style={style} onClick={this.stopPropagation.bind(this)} className="attachments-popup" aria-hidden="false" aria-autoclose="false">
                <div className="notes-dropdown-content">
                    <h3>{cacheStore.GetString("AttachmentsLabel")}</h3>
                    <div>
                        {arrAttachments}
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        window.addEventListener("resize", this.resizeHandler);
        var elem = document.getElementById("muli_file_wd");
        autosize(elem);
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    public componentWillUnmount(): void {
        window.removeEventListener("resize", this.resizeHandler);
        var elem = document.getElementById("muli_file_wd");
        var event = document.createEvent("Event");
        event.initEvent("autosize:destroy", true, false);
        elem.dispatchEvent(event);
    }

    private resizeHandler(): void {
        var operation = new LocalEvent(LocalOperations.Documents.MultiFile_Window_Resize);
        LocalEventDispatcher.dispatch(operation);
    }

    public OpenDocument(filePath: DocumentPath): void {
        const readableFileName = this.helper.GetReadableFileName(filePath.FileName);
        const docUrl = apiSettings.buildAppUrl(`api/medicalDocuments/downloadFile/${filePath.Id}/${encodeURIComponent(readableFileName)}`, { auth: true });
        MyleHelper.OpenNewWindow(docUrl);
    }
}

export { AttachmentsTooltipControl };
